import React from 'react'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { StyleService, useStyleSheet } from '@src/style/service'
import { CoachAssignment } from '@src/types'
import Intercom from '@src/utils/intercom'
import { CurrentUserQuery } from '@src/graphql/fetchUser.generated'
import { RootStackParamList } from '@src/navigation/types'
import { Coach } from './Coach'

interface CoachProps {
  coachAssignment?: CoachAssignment
  conversation?: NonNullable<CurrentUserQuery['currentUser']>['coachChatConversation']
  canSwitch: boolean
  hasUnreadMessage?: boolean
  showNewChip: boolean
}

export const StressCard = ({
  canSwitch,
  coachAssignment,
  conversation,
  hasUnreadMessage = false,
  showNewChip,
}: CoachProps) => {
  const styles = useStyleSheet(themedStyle)
  const navigation = useNavigation<StackNavigationProp<RootStackParamList>>()

  if (!coachAssignment || !coachAssignment.coach) {
    return (
      <Coach
        accessibilityLabel="Add stress coach"
        badgeLabel={showNewChip ? 'NEW' : undefined}
        iconBackgroundStyle={styles.flowerIcon}
        iconName="flower-lotus"
        onPress={() => navigation.navigate('StressManagementIntroScreen', { source: 'addons' })}
        subtitle="Feel calmer. Eat better. Recover faster."
        title="Add Stress Coach"
      />
    )
  }

  const { coach } = coachAssignment
  const { fullName, bio, photo, credentials, specialties } = coach.coachProfile || {}
  const displayName = fullName || `${coach.firstName} ${coach.lastName}`
  const { referralUrl } = coachAssignment

  const handleOpenChat = () => {
    if (!conversation) {
      return
    }

    Intercom.showIntercomConversation(conversation.intercomId)
  }

  const handleOpenBio = () => {
    navigation.navigate('CoachInfoModal', {
      variant: 'assignedCoach',
      photo,
      coachingKind: coachAssignment.coachingKind.key,
      firstName: coach.firstName,
      fullName: displayName,
      subTitle: 'Stress Coach',
      bio,
      credentials,
      specialties: specialties || [],
      referralUrl,
      coachAssignmentId: coachAssignment.id,
      showBookVideoCallButton: true,
      showChatAction: true,
      showSwitchButton: true,
      canSwitch,
    })
  }

  return (
    <Coach
      accessibilityLabel={`View ${displayName}`}
      hasUnreadMessage={hasUnreadMessage}
      onChatPress={conversation ? handleOpenChat : undefined}
      onPress={handleOpenBio}
      photo={photo}
      subtitle="Stress Coach"
      title={displayName}
    />
  )
}

const themedStyle = StyleService.create({
  flowerIcon: {
    backgroundColor: 'theme.accent.tea',
  },
})
